// extracted by mini-css-extract-plugin
module.exports = {"text":"heroSkins-mediumOnWide-text-ebf57d5a"};